import { type AppDispatch } from "features/Application/globaltypes/redux";
import {
  gotContent,
  reqContent,
  errContent,
  setIsContentLoaded,
  reqEmailTemplate,
  gotEmailTemplate,
  errEmailTemplate,
} from "../slices/emailTemplateSlice";
import DataService from "features/Application/services/dataServices/typedDataService";
import azureStorageUtils from "utils/azureStorageUtils";

export const getEmailTemplateContent = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(reqContent());
  try {
    const contentUrlWithSas: string =
      await DataService.threatDefence.campaigns.getEmailTemplateContentUrlWithSasAsync(id);
    const html = await azureStorageUtils.downloadAsString(contentUrlWithSas);
    dispatch(gotContent({ contentUrlWithSas, html }));
    dispatch(setIsContentLoaded(true));
  } catch (error: any) {
    dispatch(errContent(error));
  }
};

export const getEmailTemplate = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(reqEmailTemplate());
  try {
    const result = await DataService.threatDefence.campaigns.getEmailTemplate(id);
    dispatch(gotEmailTemplate(result.data));
  } catch (error) {
    dispatch(errEmailTemplate(error));
  }
};
